// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v4[data-v-45928946]{min-height:100vh;background-color:#f9f9f9;-webkit-box-sizing:border-box;box-sizing:border-box}.v4[data-v-45928946]:before{content:\"\";display:table}", ""]);
// Exports
module.exports = exports;
